
<div
  class="amplify-authenticator amplify-authenticator-ionic"
  *ngIf="_show"
  data-test="require-new-password-section"
  >
  <div class="amplify-form-body" data-test="require-new-password-body-section">
    <div
      class="amplify-form-header amplify-form-header-ionic"
      data-test="require-new-password-header-section"
      >
      {{ this.amplifyService.i18n().get('Reset your password') }}
    </div>
    <ion-list>
      <ion-item lines="none">
        <ion-label class="amplify-input-label amplify-input-label-ionic" position="stacked">
          {{ this.amplifyService.i18n().get('Password') }}
        </ion-label>
        <ion-input
          #password
          type="password"
          class="amplify-form-input"
          (input)="setPassword(password.value)"
          (keyup.enter)="onSubmit()"
          data-test="require-new-password-new-password-input"
        ></ion-input>
      </ion-item>

    </ion-list>

    <div class="amplify-form-actions">
      <div class="amplify-form-row">
        <ion-button
          expand="block"
          (click)="onSignIn()"
          data-test="require-new-password-back-to-sign-in-link"
        >{{ this.amplifyService.i18n().get('Back to Sign In') }}</ion-button>
      </div>
      <div class="amplify-form-row">
        <ion-button
          expand="block"
          (click)="onSubmit()"
          data-test="require-new-password-submit-button"
        >Submit</ion-button>
      </div>
    </div>
  </div>
  <div class="amplify-alert" *ngIf="errorMessage">
    <div class="amplify-alert-body">
      <span class="amplify-alert-icon">&#9888;</span>
      <div class="amplify-alert-message">{{ errorMessage }}</div>
      <a class="amplify-alert-close" (click)="onAlertClose()">&times;</a>
    </div>
  </div>
</div>
